import { Animated, Easing, Platform } from 'react-native';
export var startLoadingAnimation = animatedRotation => {
  Animated.loop(Animated.timing(animatedRotation, {
    toValue: 1,
    duration: 1000,
    easing: Easing.linear,
    useNativeDriver: Platform.OS !== 'web'
  })).start();
};
export var getInterpolatedRotationValue = animatedRotation => {
  return animatedRotation.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '360deg']
  });
};